import { createEffect, createSignal, lazy, Match, onMount, Setter, Show, Switch } from "solid-js";
import { useApp, UserContext } from "./context";
import { get_status, login_basic, LoginInfo, Permission, request_pw_reset, UserIdentifier } from "./api";
import { login_srp, register_str, logout  } from "./api_common";
import { Input } from "./common";
import Register from "./register";

export function UserLogin({
  user,
}: {
  user: UserContext;
}) {
  let user_input: HTMLInputElement;
  let password: HTMLInputElement;
  let [progress, setProgress] = createSignal("");

  onMount(() => {
    const origin = `${window.location.protocol}//${window.location.host}`;
    window.addEventListener(
    "message",
    (event) => {
      console.log(event);
      if (event.origin !== origin) return;

      const data = event.data;
      if (data.type == "login_success") {
        get_status().then(status => user.setUser(status));
      }
    });
  });

  const login = (mode: "srp"|"basic") => {
    let args = {
      password: password.value,
      ident: "email:" + user_input.value
    };
    setProgress("logging in");
    let p: Promise<LoginInfo>;
    if (mode === "srp") {
      p = login_srp(args, progress)
    } else {
      p = login_basic(args);
    }
    p.then((info) => {
        user.setUser(info);
      },
      (error) => setProgress(error)
    );
  };
  const [showSignUp, setShowSignUp] = createSignal(false);
  const sign_up = () => {
    setShowSignUp(true);
  };

  return (
    <div class="login">
      <form method="dialog">
        <Show when={showSignUp() === false}>
          <Input
            label="Email"
            type="email"
            autocomplete="email"
            ref={user_input}
          />

          <Input
            label="Password"
            type="password"
            autocomplete="current-password"
            ref={password}
          />
          <button type="submit" on:click={() => login("srp")}>
            Login (SRP)
          </button>
          <button type="submit" on:click={() => login("basic")}>
            Login (basic)
          </button>

          <button on:click={() => window.open("/oauth2/authorization/google/oidc", "_blank")}><img class="icon" src="/style/icons/google.svg" />Login with Google</button>
          <button on:click={() => window.open("/oauth2/authorization/dropbox/oidc", "_blank")}><img class="icon" src="/style/icons/dropbox.svg" />Login with Dropbox</button>

          <button type="submit" on:click={sign_up}>
            Sign up
          </button>
        </Show>

        <div>{progress()}</div>
      </form>

      <Show when={showSignUp() === true}>
        <Register />
      </Show>
    </div>
  );
}
export function AdminLogin({
  user,
  permission
}: {
  user: UserContext;
  permission?: Permission[]
}) {
  let user_input: HTMLInputElement;
  let password: HTMLInputElement;
  let [progress, setProgress] = createSignal("");

  const login = (mode: "srp"|"basic") => {
    let ident: string;
    if (user_input.value.includes("@")) {
      ident = "email:" + user_input.value;
    } else {
      ident = "user:" + user_input.value;
    }
    let args = {
      password: password.value,
      ident
    };
    setProgress("logging in");
    let p: Promise<LoginInfo>;
    if (mode === "srp") {
      p = login_srp(args, progress)
    } else {
      p = login_basic(args);
    }
    p.then((info) => {
        for (const p of permission || []) {
          if (info.permissions.findIndex(u => p === u) < 0) {
            setProgress(`permission ${p} missing`);
            return;
          }
        }
        user.setUser(info);
      }, (error) => setProgress(error));
  };
  return (
    <div class="login">
      <form method="dialog">
          <Input
            label="User"
            type="text"
            autocomplete="username"
            ref={user_input}
          />

          <Input
            label="Password"
            type="password"
            autocomplete="current-password"
            ref={password}
          />
          <button type="submit" on:click={() => login("srp")}>
            Login (SRP)
          </button>

        <div>{progress()}</div>
      </form>
    </div>
  );
}


export function UserStatus() {
  const { user } = useApp();

  function log_out() {
    user.setUser(null);
    logout();
  }

  return (
    <Switch>
      <Match when={user.user() !== null}>
        <div>
          {user.user().email} <button onclick={log_out}>Log out</button>
        </div>
      </Match>
      <Match when={user.user() === null}>
        <UserLogin user={user} />
      </Match>
    </Switch>
  );
}

export function Logout() {
    const { user } = useApp();

  function log_out() {
    user.setUser(null);
    logout();
  }

  return <Show when={user.user() !== null}>
    <div>
      {user.user().email} <button onclick={log_out}>Log out</button>
    </div>
  </Show>
}

export function User() {
  const { user } = useApp();
  let popover: HTMLDivElement;

  function log_out() {
    user.setUser(null);
    logout();
  }
  createEffect(() => {
    if (user.user() !== null) {
      popover.hidePopover();
    }
  })
  return <>
      <div id="popover" popover ref={popover}>
        <div class="frame">
          <UserLogin user={user} />
        </div>
      </div>
      <Switch>
        <Match when={user.user() !== null}>
          <div>
            {user.user().email} <button onclick={log_out}>Log out</button>
          </div>
        </Match>
        <Match when={user.user() === null}>
          <div>
            <button popovertarget="popover" popovertargetaction="show">Log in</button>
          </div>
        </Match>
    </Switch>
  </>
}
